import { useLocation } from "react-router-dom";
import Sidang from "./mkspesial/Sidang";
import RiwayatMKSpesial from "./mkspesial/riwayat/RiwayatMKSpesial";

export default function SidangMahasiswa() {
  const { state } = useLocation();

  return (
    <>
      {!state && <RiwayatMKSpesial />}
      {state && state.display === "details" && (
        <Sidang
          mKSpesialId={state.mKSpesialId}
          jenisSidang={state.jenisSidang}
        />
      )}
    </>
  );
}
